import React, { useEffect } from "react";
import Modal from "react-responsive-modal";
import "react-responsive-modal/styles.css";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import LogController from "../../controller/LogController";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";
import { arraivalAudio } from "../../utils/Audio";

let arrivalTimer: any;

const ArrivalModal = (oProps: {
  isVisible: boolean;
  setVisible: any;
  pickup_name: string;
  pickup_name_en: string;
}) => {
  const lang = useRecoilValue<number>(langState);

  const onCloseModal = () => {
    oProps.setVisible(false);
    LogController.click({
      path: "ArrivalModal",
      params: "arrival",
      params2: "사용자가 주문도착 모달 닫음",
    });
  };

  const playArrivalAudio = () => {
    if (arraivalAudio) {
      arrivalTimer = setTimeout(() => {
        arraivalAudio.currentTime = 0;
        arraivalAudio.play();
      }, 5000);
    }
  };

  useEffect(() => {
    clearTimeout(arrivalTimer);
    arrivalTimer = null;
  }, []);

  // Audio 재생
  useEffect(() => {
    if (oProps.isVisible) {
      LogController.event({
        path: "ArrivalModal",
        params: "arrival",
        params2: "주문도착 모달 열림",
      });

      if (arraivalAudio) {
        arraivalAudio.currentTime = 0;
        arraivalAudio.play();
        arraivalAudio.addEventListener("ended", playArrivalAudio);
      } else {
        clearTimeout(arrivalTimer);
        arrivalTimer = null;
      }

      return () => {
        arraivalAudio.removeEventListener("ended", playArrivalAudio);
      };
    }
  }, [oProps.isVisible]);

  return (
    <Modal
      open={oProps.isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: "arrivalModalOverlay",
        modal: "arrivalModal",
      }}
      closeOnOverlayClick={false}
      showCloseIcon={false}
      animationDuration={150}
    >
      <Style>
        <div className="modal">
          <img
            src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_location.svg`}
            alt="ic"
          />
          <p className="titleFont">{langText.arrivalModal_title[lang]}</p>
          <div>
            <h1>{lang === 0 ? oProps.pickup_name : oProps.pickup_name_en}</h1>
          </div>
          <div className="confirmButton" onClick={onCloseModal}>
            {langText.button_confirm[lang]}
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default ArrivalModal;

const Style = styled.div`
  img {
    padding-bottom: 6px;
  }
  .modal {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 8%;
    width: 100%;
    height: 100%;
  }
  .titleFont {
    font-size: 20px;
    line-height: 32px;
    font-weight: 400;
    color: #000000;
    text-align: center;
    margin: 0 0;
  }

  h1 {
    text-align: center;
    line-height: 48px;
    color: #40977f;
    font-weight: 600;
  }
  .confirmButton {
    width: 90%;
    padding: 16px;
    background: #4dd2ae;
    font-size: 24px;
    line-height: 32px;
    border-radius: 10px;
    color: #ffffff;
    font-weight: 600;
    text-align: center;
  }
`;
